// ----------------------------------------------------------------------
// <copyright file="Izenda.SettingPage.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Setting page component
 */

import React, { Component } from 'react';
import IntegrationContainer from '../Izenda.IntegrationContainer';
import SettingsRoot from '../modules/Settings/Izenda.SettingsRoot';
import { Integration } from 'config';
import getHistory from '../Izenda.History';
import routeUtils from '../share/utils/Izenda.RouteUtils';
import IntegrationRoutes from '../routes/Izenda.IntegrationRoutes';
import { Router } from 'react-router';

export default class SettingPage extends Component {
  constructor(props: any) {
    super(props);

    this.history = getHistory(Integration);
    if (!Integration) return;
    routeUtils.listenHistoryChange(this.history, this.getSettingRoute().path);
  }

  /**
   * Get setting route
   */
  getSettingRoute() {
    return { path: routeUtils.getSettingsUrl() };
  }

  render() {
    const { synergyHistory } = this.history;
    return <Router history={synergyHistory}>{IntegrationRoutes(this.getSettingRoute())}</Router>;
  }
}



// WEBPACK FOOTER //
// ./ui/pages/Izenda.SettingPage.js